<template>
  <div class="container white pa-0">
    <!-- alerta -->
    <v-snackbar top v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark icon text @click="snackbar = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-layout column class="menu w-100 white">
      <v-card elevation="2" tile>
        <v-layout
          align-center
          justify-space-around
          class="py-2 px-3 colorSelectedBack sizeTop"
        >
          <img
            :src="require(`@/assets/logos/usecargobranco.png`)"
            alt="pickndrive"
            style="width: auto; height:39px;"
          />
        </v-layout>
      </v-card>
    </v-layout>

    <div style="height:48px"></div>

    <!-- Rescues model -->
    <v-dialog v-model="rescues_show_dialog" width="500">
      <v-card class="reward-dialog" id="rescues_dialog">
        <div class="invite-title-3"> MEUS CUPONS </div>
        <v-simple-table dense v-if="rescues && rescues.length > 0">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"> Código </th>
                <th class="text-left"> Validade </th>
                <th class="text-left"> Utilizado </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rescue in rescues" :key="rescue.id">
                <td>{{ rescue.coupon.name }}</td>
                <td>{{ formatDate(rescue.coupon.expiration_date) }}</td>
                <td>
                  <v-checkbox v-model="rescue.used" disabled>
                  </v-checkbox>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="invite-title-2" v-else style="margin-bottom: 15px; color: #000;">
          Nenhum cupom resgatado!
        </div>
        <v-btn large block class="btnSecundaryColor text-white"
        @click="rescues_show_dialog = false">
          Fechar
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Reward activation model -->
    <v-dialog v-model="reward_show_dialog" width="500">
      <v-card class="reward-dialog">
        <img
          :src="require(`@/assets/rewards/present_open.png`)"
          alt="presente aberto"
        />
        <div class="invite-title-3"> PARABÉNS </div>
        <div class="invite-sub-title-2 text-center">
          {{ reward_dialog ? reward_dialog.message : '' }}
          <br>Aproveite seu prêmio!
        </div>
        <v-btn large block class="btnSecundaryColor text-white"
        @click="activateReward(reward_dialog)">
          Pegar
        </v-btn>
      </v-card>
    </v-dialog>

    <!-- Cupom dialog -->
    <v-dialog v-model="coupon_show_dialog" width="500">
      <v-card class="reward-dialog">
        <div class="coupon-box">
          <div>
            <span>
              Cupom
            </span>
            {{ coupon }}
          </div>
        </div>
        <div class="invite-sub-title-2">
          Anote o seu cupom e utilize na próxima viagem!
        </div>
        <v-btn large block class="btnSecundaryColor text-white"
        @click="() => { coupon_show_dialog = false; coupon = '' }">
          OK
        </v-btn>
      </v-card>
    </v-dialog>

    <v-container>
      <div class="invite-back" @click="$router.go(-1)">
        <v-icon> mdi-chevron-left </v-icon>
      </div>
      <div class="invite-title">
        Indique pessoas, receba cashback e concorra a prêmios
      </div>
      <div class="invite-sub-title">
        Compartilhe seu código com amigos. A cada novo usuário indicado, você fica mais próximo de conquistar benéficios.
      </div>
      <div class="invite-code-box" @click="copyInvitationCode('#invite_code')">
        <input type="hidden" id="invite_code" :value="indication_code">
        <span id="code">{{ indication_code }}</span>
        <span id="button">{{ copy }}</span>
      </div>
        <!--<input type="hidden" id="invite_code" :value="indication_code">
        <v-btn large class="btn-invite mx-0 " @click="copyInvitationCode('#ivite_link')">
          Copiar
        </v-btn>-->
      <input type="hidden" id="ivite_link" :value="'https://usecargoapp.mobi/cadastrar-usuario/'+indication_code">
      <v-btn large color="#55AE6A" class="btn-whatsapp" @click="compartilhar()">
        WhatsApp
      </v-btn>
      <div class="rewards-tile">
        <div class="rewards-inner-tile">
          <img
            :src="require(`@/assets/rewards/rewards.png`)"
            alt="rewards"
          />
          <div>
            <span> Recompensas </span>
          </div>
        </div>
        <div>
          <v-btn small @click="getRescues()">
            Meus Cupons
          </v-btn>
        </div>
      </div>
      <ul>
        <li v-for="reward in rewards" :key="reward.id">
          <div class="reward-card">
            <div class="reward-inner-card">
              <div class="reward-card-title">
                {{reward.name}}
              </div>
              <div class="reward-progress">
                <div class="reward-progress-bar">
                  <v-progress-linear
                    v-bind:value="getProgressPercentage(reward.number_of_indications)"
                    rounded
                    background-color="#30508e"
                    background-opacity="0.3"
                    color="#30508e"
                  >
                  </v-progress-linear>
                  <img
                    :src="require(`@/assets/rewards/car.png`)"
                    alt="carro"
                    ref="progress_car"
                  />
                </div>
                <span class="reward-invitations">
                  {{invitations}}/{{reward.number_of_indications}}
                </span>
              </div>
            </div>
            <div class="reward-card-icon">
              <img
                v-if="invitations < reward.number_of_indications"
                :src="require(`@/assets/rewards/present_inactive.png`)"
                alt="presente inativo"
              />
              <img
                v-if="invitations >= reward.number_of_indications"
                :src="require(`@/assets/rewards/present_active.png`)"
                alt="presente ativo"
                @click="showRewardActivationDialog(reward)"
                id="active-button-icon"
              />
            </div>
          </div>
        </li>
      </ul>
      <div class="invite-title-2">
        Entenda como funciona:
      </div>
      <div class="invite-sub-title">
        <p>
          A cada 10 novos usuários indicado por você que vier a concluir um cadastro, você receberá 1 hora off para usar o carro do seu condomínio.
        </p>
        <p>
          Assim que completar as 10 indicações receberá um cupom de desconto para ser utilizado em qualquer reserva.
        </p>
      </div>
    </v-container>
  </div>
</template>

<script>
import theming from "../../mixins/theming";
import DateHelper from '../../helpers/DateHelper'
import UserController from "../../controllers/UserController";
import RewardsController from '../../controllers/RewardsController';
import RescuesController from '../../controllers/RescuesController';
import 'animate.css';

export default {
  mixins: [theming],

  components: {},

  async created() {
    this.getIndicationCode();
    this.getRewards();
  },

  mounted() {
    this.getInvitationsMade();
  },

  data() {
    return {
      userController: new UserController(this.$resource),
      rewardsController: new RewardsController(this.$resource),
      rescuesController: new RescuesController(this.$resource),

      snackbarText: "",
      snackbarColor: "",
      snackbar: false,
      indication_code: "",
      copy: 'COPIAR',
      userId: localStorage.getItem("pickn_user"),

      reward_dialog: null,
      reward_show_dialog: false,
      rescues_show_dialog: false,
      coupon_show_dialog: false,
      coupon: '',
      invitations: 0,
      rewards: [],
      rescues: [],
    };
  },

  methods: {
    formatDate(date) {
      return DateHelper.formatDate(date);
    },

    getRescues() {
      this.rescuesController.getRescuesByUserId(this.userId)
      .then(res => {
        this.rescues = res;
        this.rescues_show_dialog = true;
      });
    },

    activateReward(reward) {
      this.rescuesController.createRescue(reward.id)
      .then(res => {
        this.reward_dialog = null;
        this.reward_show_dialog = false;
        this.coupon = res.coupon;
        this.coupon_show_dialog = true;
        this.getInvitationsMade();
      });
    },

    getRewards() {
      this.rewardsController.getAllRewards()
      .then(res => this.rewards = res);
    },

    showRewardActivationDialog(reward) {
      this.reward_show_dialog = true;
      this.reward_dialog = reward;
    },

    getProgressPercentage(number_of_indications) {
      let percentage = (this.invitations*100)/number_of_indications;
      percentage = (percentage > 100 ? 100 : percentage);
      return percentage;
    },

    updateRewardsStatus() {
      this.rewards.forEach((reward, index) => {
        const { number_of_indications, activation_message, active } = reward;
        if (active)
          this.updateProgressCarPosition(index, 100);
        else
          this.updateProgressCarPosition(index, this.getProgressPercentage(number_of_indications));
      })
    },

    updateProgressCarPosition(index, percentage) {
      if(this.$refs["progress_car"])
        this.$refs["progress_car"][index].style.left = `${percentage}%`;
    },

    getIndicationCode(){
      this.userController.getUserInvitationCode(this.userId)
      .then(res => this.indication_code = res);
    },

    getInvitationsMade(){
      this.userController.getUserInvitationsMake(this.userId)
      .then(res => {
        this.invitations = res.invitationsMake;
        this.updateRewardsStatus()
      });
    },

    copyInvitationCode (idSelector) {
      let codeToCopy = document.querySelector(idSelector)
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()

      try {
        var successful = document.execCommand('copy');
        this.copy = successful ? 'COPIADO': 'COPIAR';
      } catch (err) {
        console.log('Oops, unable to copy');
      }

      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },

    compartilhar(){
      window.open(`https://wa.me/?text=https://usecargoapp.mobi/cadastrar-usuario/${this.indication_code}`, "_system", 'location=no')
    },

    identifyAndroid() {
      if (navigator.userAgent.match(/Android/i)) {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style scoped>
.coupon-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 20px;
  line-height: 27px;
  font-weight: 600;
  width: 100%;
}

.coupon-box span {
  top: -8.5px;
  left: 3%;
  position: absolute;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  background: #fff;
  padding: 0 5px;
}

.coupon-box div {
  position: relative;
  text-align: center;
  width: 100%;
  border: 1px solid #EAEAEA;
  border-radius: 4px;
  padding: 12px;
}

#active-button-icon {
  animation: pulse;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-delay: 1s;
}

ul, li {
  margin: 0;
  padding: 0;
  list-style-type: none
}

.invite-back{
  position: absolute;
}
.invite-back i {
  color: black;
}

.invite-title, .invite-title-2, .invite-title-3{
  text-align: center;
  max-width: 300px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 20px;
}
.invite-title-2 {
  margin-top: 22px;
  color: #30508E;
}
.invite-title-3 {
  margin-top: 15px;
  font-size: 20px;
  line-height: 27px;
  font-weight: 600;
}

#rescues_dialog .invite-title-3 {
  margin-top: 0;
  margin-bottom: 15px;
}

#rescues_dialog .v-data-table {
  margin-bottom: 15px;
}

.invite-sub-title, .invite-sub-title p{
  font-size: 14px;
  line-height: 20px;
}

.invite-sub-title {
  margin: 10px 0 15px 0;
}

.invite-sub-title-2{
  font-size: 12px;
  line-height: 17px;
  margin: 18px 0;
}

.invite-code-box{
  display: flex;
  border: 1px solid #30508E;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
}

.invite-code-box #code{
  font-size: 14px;
}

.invite-code-box #button{
  font-weight: 600;
  font-size: 14px;
  color: #30508E;
}

.btn-whatsapp{
  width: 100%;
  margin: 15px 0 20px 0;
  color: #FFF;
  text-transform: none;
}

.rewards-tile {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 15px;
}

.rewards-tile .rewards-inner-tile {
  display: flex;
}

.rewards-tile .rewards-inner-tile div {
  display: flex;
  align-items: flex-end;
  margin-left: 10px;
  font-size: 16px;
  line-height: 14px;
}

.rewards-tile img {
  width: 34.14px;
}

.reward-card {
  background-color: #EAEAEA;
  padding: 12px 8px;
  margin: 8px 0;
  display: flex;
  justify-content: space-between;
}

.reward-card-title {
  font-size: 14px;
  margin-bottom: 5px;
}

.reward-inner-card{
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
}

.reward-card-icon{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.reward-card-icon img{
  margin-left: 25px;
  width: 53.76px;
}

.reward-progress {
  width: 100%;
}

.reward-progress-bar {
  height: 20px;
  display: flex;
  align-items: center;
  margin: 5px 0;
  position: relative;
}

.reward-progress-bar .v-progress-linear {
  transition-duration: 1s;
}

.reward-progress-bar img {
  top: 0;
  left: 0;
  transform: translateX(-8px);
  position: absolute;
  width: 42px;
  transition: 1s cubic-bezier(0.4, 0, 0.6, 1);
}

.reward-invitations{
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  color: #6D6C6B;
}

.reward-dialog {
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.reward-dialog img {
  width: 210.24px;
}

.container {
  padding-bottom: 45px;
}

.sizeTop {
  height: 48px;
}

.menu {
  position: fixed;
  top: 0px;
  z-index: 1;
}

.colorSelectedBack {
  background-color: var(--secondary-color) !important;
}

.colorSelected {
  color: var(--secondary-color) !important;
}

.card {
  position: relative;
}

.cardRadius {
  border-radius: 4px;
}

.float {
  position: absolute;
  top: 4px;
  right: 3px;
  outline: none;
}

.floatMiddle {
  position: absolute;
  outline: none;
  left: 50%;
  margin-left: -20px;
  top: 50%;
  margin-top: -20px;
}

.btnSecundaryColor {
  background-color: var(--secondary-color) !important;
}

.btnColor {
  background-color: var(--secondary-color) !important;
  color: var(--secondary-color) !important;
}
</style>
